import { Component, OnInit, Injector } from '@angular/core';
import { disconnectionInfoModal } from '../disconnectionInfo/disconnectionInfoModal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mobile-disconnection-info-modal',
  template: require('./mobile-disconnection-info-modal.component.html'),
  styles: [require('./mobile-disconnection-info-modal.component.css')]
})
export class MobileDisconnectionInfoModalComponent extends disconnectionInfoModal {

  constructor(

    injector: Injector,
    public activeModal: NgbActiveModal,
  ) {
      super(injector, activeModal);
  }

}
